import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@icon/Icon';
const TEARDROP_PATH = 'M12 0C5.373 0 0 5.373 0 12c0 8.25 12 24 12 24s12-15.75 12-24C24 5.373 18.627 0 12 0z';
/**
 * @export
 *
 * @partOf MapComponent
 */
export const MapMarker = ({ color, icon, iconColor = '#fff', size = 36 }) => {
    const height = size;
    const width = Math.round((size * 20) / 30);
    return (_jsxs("div", { style: { color: color || 'var(--accentColor, #3388ff)', position: 'relative', width, height, lineHeight: 0 }, children: [_jsxs("svg", { width: width, height: height, viewBox: "0 0 24 36", style: { display: 'block' }, children: [_jsx("path", { d: TEARDROP_PATH, fill: "currentColor", stroke: "#fff", strokeWidth: 1.5 }), !icon && _jsx("circle", { cx: 12, cy: 12, r: 4.5, fill: "#fff" })] }), icon ? (_jsx("div", { style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width,
                    height: width,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: iconColor,
                    fontSize: `${Math.round(width * 0.55)}px`,
                }, children: _jsx(Icon, { icon: icon, color: iconColor }) })) : null] }));
};
export default MapMarker;
